import React, {Component, useRef} from 'react';
import "../../style/Statistics.scss"
import {css} from "@emotion/css";
import {convertCurrencyFormatPositiveNegative} from "../../util/numberConvertor";
import useDraggableScroll from "use-draggable-scroll";


const Statistics = () => {
    const ref = useRef(null);
    const {onMouseDown} = useDraggableScroll(ref, {direction: 'horizontal'});
    return (
        <div className="statisticsContainer hideScroll" ref={ref} onMouseDown={onMouseDown}>
            {
                dashboardReportsColumns.map((item, index) => {
                    return <div key={index} className="default-card-container-background-style statisticsContent">
                        <div className={css`
                          background: var(${item.highlightColor});
                          border-radius: var(--default-border-radius);
                          width: fit-content;
                          height: fit-content;
                        `}>
                            <div className={`${item.icon} ${css`
                              background: var(${item.primaryColor});
                              padding: 20px;
                            `}`}/>
                        </div>
                        <span className={
                            css`font-size: var(--text-size-default);
                              color: var(--color-variant);
                              margin-top: 16px;
                            `}>
                                    {item.title}
                        </span>
                        <div className={css`display: flex;
                          flex-direction: row;
                          flex-wrap: nowrap;
                          margin-top: 8px;
                          align-items: baseline;
                          gap: 8px;`}>
                                    <span className={
                                        css`font-size: var(--text-size-large);
                                          color: var(--color-text);
                                        `}>
                                            {convertCurrencyFormatPositiveNegative(item.amount)}
                                    </span>

                            <span className={
                                css`font-size: var(--text-size-min);
                                  color: var(--color-variant);
                                `}>
                                            {item.unit}
                            </span>

                        </div>

                    </div>
                })
            }
        </div>
    )
}
export default Statistics;

const dashboardReportsColumns = [{
    title: "مورد اول",
    amount: "2",
    icon: "ic-areas",
    primaryColor: "--color-purple",
    highlightColor: "--color-Purple-highlight",
    unit: "عدد"
}, {
    title: "مورد دوم",
    amount: "17",
    icon: "ic-bases",
    primaryColor: "--color-blue",
    highlightColor: "--color-Blue-highlight",
    unit: "عدد"
}, {
    title: "مورد سوم",
    amount: "313",
    icon: "ic-users",
    primaryColor: "--color-orange",
    highlightColor: "--color-Orange-highlight",
    unit: "عدد"
}, {
    title: "مورد چهارم",
    amount: "5480000",
    icon: "ic-game-play",
    primaryColor: "--color-red",
    highlightColor: "--color-Red-highlight",
    unit: "عدد"
}, {
    title: "مورد پنجم",
    amount: "4750000",
    icon: "ic-game-play",
    primaryColor: "--color-green",
    highlightColor: "--color-Green-highlight",
    unit: "عدد"
}]
